import React from "react";
import { useSelector } from "react-redux";
import Loading from "components/atoms/Loading";
// import Common from "./commonSlice";

function Error() {
  const loading = useSelector((state: any) => state.common.loading) as any;

  return (
    <React.Fragment>
      <Loading loading={loading} />
    </React.Fragment>
  );
}

export default Error;
